export default "<voting-list data-voting-id=\"\">@{}</voting-list>";